import { RadioButtonGroup, Toast } from '@clickcease/cc-client-components-lib'
import React from 'react'
import { Label, ToastContainer, cssHover } from '../CancelModal.styled'
import { useTranslation } from 'react-i18next'
import { ProductTypesWithoutBundle } from 'Types/ProductTypes'
import { useIsProductTrial } from 'Hooks/trial/useIsProductTrial'
import { useIsTrialSubscription } from 'Hooks/trial/useIsTrialSubscription'

type CancelProductPartProps = {
  error: boolean
  product?: ProductTypesWithoutBundle
  productOptions: { value: string; label: string; alert: string }[]
  setProduct: (product: ProductTypesWithoutBundle) => void
}

export const CancelProductPart = ({
  error,
  product,
  productOptions,
  setProduct,
}: CancelProductPartProps) => {
  const { t } = useTranslation('accountSettings')
  const isTrialSubscription = useIsTrialSubscription()
  const { isProductInTrial } = useIsProductTrial()

  const alertText = () => {
    const status = t(
      `plan_details.reason_modal.platforms.${isProductInTrial(product) ? 'trial' : 'subscription'}`
    )
    return t(
      `${productOptions.find((option) => option.value === product)?.alert || ''}${
        isTrialSubscription ? '_account_trial' : ''
      }`,
      {
        status,
      }
    )
  }

  return (
    <>
      <Label error={error}>{t('plan_details.reason_modal.platforms.title')}</Label>
      <RadioButtonGroup
        options={productOptions}
        onChange={(value) => setProduct(value as ProductTypesWithoutBundle)}
        selectedValue={String(product)}
        css={cssHover}
      />
      {product && alertText() && (
        <ToastContainer>
          <Toast type="failure">{alertText()}</Toast>
        </ToastContainer>
      )}
    </>
  )
}
